import { render, staticRenderFns } from "./ReqTrasladoLocFormComponent.vue?vue&type=template&id=09045f9c&"
import script from "./ReqTrasladoLocFormComponent.vue?vue&type=script&lang=js&"
export * from "./ReqTrasladoLocFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports